import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * project.store.ts — Proyecto/temporada activo (F1).
 *
 * El selector global del `TopBar` escribe aquí y las páginas filtran por él.
 * Sustituye el "teclea loteId + ciclo" que hoy exige `CropPage`: la temporada
 * es contexto de la sesión, no un dato que el usuario deba repetir en cada
 * pantalla.
 *
 * `null` = todos los proyectos (sin filtrar).
 */
interface ProjectState {
  activeProjectId: string | null;
  activeProjectName: string | null;
  setActiveProject: (projectId: string | null, name?: string | null) => void;
  clearActiveProject: () => void;
}

export const useProjectStore = create<ProjectState>()(
  persist(
    (set) => ({
      activeProjectId: null,
      activeProjectName: null,
      setActiveProject: (projectId, name) =>
        set({ activeProjectId: projectId, activeProjectName: projectId ? name ?? null : null }),
      clearActiveProject: () => set({ activeProjectId: null, activeProjectName: null }),
    }),
    { name: 'agrovid-project' },
  ),
);
